import { RootState } from '../store/store';
import { getAccountType, useAccountType } from './useAccountType';

// Plain function for use with state
export function isAdmin(state: RootState): boolean {
  return getAccountType(state) === 'alpha_admin';
}

// Hook version for use in components
export function useIsAdmin(): boolean {
  const accountType = useAccountType();
  return accountType === 'alpha_admin';
}
